<!--
 * @Author: 张明浩
 * @Date: 2021-03-10 09:23:18
 * @LastEditTime: 2021-03-10 10:19:18
 * @LastEditors: Please set LastEditors
 * @Description: 数据审批
 * @FilePath: \wiz_standard_ui\src\views\dataReception\dataApproval.vue
-->
<template>
  <div id="dataApproval" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex" justify="space-between">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-input
          size="small"
          v-model="approvalNum"
          class="w-200px mr-10px ml-10px"
          :placeholder="$t('审批批次号')"
          clearable
          @keyup.enter.native="searchTableData"
        ></el-input>
        <el-select
          class="w-200px mr-10px"
          v-model="approvalTable"
          :placeholder="$t('审批数据表')"
          clearable
          size="small"
        >
          <el-option
            v-for="(item, index) in classList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          class="w-200px mr-10px"
          v-model="approvalStatus"
          :placeholder="$t('审批状态')"
          clearable
          size="small"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="startDate"
          type="date"
          :placeholder="$t('开始日期')"
          size="small"
          class="w-200px mr-10px"
        >
        </el-date-picker>
        <el-date-picker
          v-model="endDate"
          type="date"
          :placeholder="$t('结束日期')"
          size="small"
          class="w-200px mr-10px"
        >
        </el-date-picker>
        <el-input
          size="small"
          v-model="approvalUser"
          class="w-200px mr-10px"
          :placeholder="$t('操作者')"
          clearable
          @keyup.enter.native="searchTableData"
        ></el-input>
        <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="openDialog('add')">{{
          $t('create')
        }}</el-button>
        <el-button @click="reset">{{ $t('reset') }}</el-button>
      </el-row>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 106px)"
        class="mt-20px"
        ref="tableList"
      >
        <!-- <el-table-column type="index" label="序号" width="50"></el-table-column> -->
        <el-table-column
          :label="$t('数据标准库')"
          prop="standardName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('审批批次号')"
          prop="batchCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('数据表')"
          prop="tableName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column :label="$t('审批状态')" prop="processStatus" width="100">
          <template slot-scope="scoped">
            <el-tag type="info" v-if="scoped.row.processStatus === 0" size="mini">{{
              scoped.row.processStatusStr
            }}</el-tag>
            <el-tag type="success" v-else-if="scoped.row.processStatus === 1" size="mini">{{
              scoped.row.processStatusStr
            }}</el-tag>
            <el-tag type="danger" v-else size="mini">{{ scoped.row.processStatusStr }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('审批意见')"
          prop="approvalOpinions"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('操作者')"
          prop="processUserId"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scoped">
            <div v-for="(item, index) in userList" :key="index">
              {{ scoped.row.processUserId === item.id ? item.name : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('操作时间')"
          prop="lastModifiedTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column :label="$t('操作')" fixed="right" width="200">
          <template slot-scope="scope">
            <!-- 待审批和审批驳回状态,可以编辑 -->
            <el-button
              @click="openDialog('edit', scope.row)"
              size="mini"
              :disabled="!$hasAccess('update') || !_.includes([0, 2], scope.row.processStatus)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              @click="toDetail(scope.row, 'preview')"
              size="mini"
              :disabled="!$hasAccess('preview')"
              >预览</el-button
            >
            <!-- 待审批状态才能进行审批 -->
            <el-button
              @click="toDetail(scope.row)"
              size="mini"
              :disabled="!$hasAccess('approval') || scope.row.processStatus !== 0"
              >{{ $t('审批') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="searchTableData"
        @current-change="getTableData"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="page.recordCount"
      ></el-pagination>
    </el-card>

    <!-- 新增和编辑对话框 -->
    <el-dialog
      :title="type === 'add' ? $t('数据审批设置') : $t('数据审批编辑')"
      :visible.sync="visible"
      :close-on-click-modal="false"
      class="small-dialog"
      v-dialogDrag
      v-if="visible"
    >
      <div>
        <el-form label-width="150px" :model="form" :rules="rules" ref="form">
          <el-form-item :label="$t('数据标准库')" prop="standardId">
            <el-select
              v-model="form.standardId"
              :placeholder="$t('请选择数据标准库')"
              clearable
              size="small"
              @change="changeAddStandardId"
              :disabled="type === 'edit'"
              filterable
            >
              <el-option
                v-for="(item, index) in standardList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('数据表')" prop="classId">
            <el-select
              v-model="form.classId"
              :placeholder="$t('请选择数据表')"
              clearable
              size="small"
              @change="changeAddClassId"
              :disabled="type === 'edit'"
              filterable
            >
              <el-option
                v-for="(item, index) in addClassList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('批次号')" prop="batchCode" v-if="type === 'edit'">
            <el-input
              size="small"
              v-model="form.batchCode"
              clearable
              :disabled="type === 'edit'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('审批人')" prop="processUserId">
            <el-select
              v-model="form.processUserId"
              :placeholder="$t('请选择审批人')"
              clearable
              filterable
              size="small"
            >
              <el-option
                v-for="(item, index) in userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="tc" slot="footer">
        <el-button
          size="small"
          type="primary"
          @click="submitData()"
          :loading="submitLoading"
          :disabled="submitLoading"
          >{{ $t('save') }}</el-button
        >
        <el-button size="small" type="default" @click="visible = false">{{
          $t('cancel')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dataService from '@/services/DataReceptionService'
import StandardManagementService from '@/services/common/StandardManagementService'
import stdClassListService from '@/services/stdClassListService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataApproval',
  components: {
    selectStandardId,
  },
  data() {
    return {
      tableLoading: false,
      approvalNum: '', // 审批批次号
      approvalTable: '', // 审批数据表
      approvalStatus: '', // 审批状态
      statusList: [
        { name: '待审批', id: 0 },
        { name: '审批通过', id: 1 },
        { name: '审批驳回', id: 2 },
      ],
      startDate: '', // 开始日期
      endDate: '', // 结束日期
      approvalUser: '', // 操作人
      page: {
        pageSize: 15,
        pageNo: 1,
        recordCount: 20,
      },
      tableData: [],
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      standardList: [],
      classList: [],
      visible: false,
      type: '',
      form: {
        standardId: '',
        standardCode: '',
        classId: '',
        classCode: '',
        processUserId: '',
      },
      rules: {
        standardId: [{ required: true, message: '请选择数据标准库', trigger: 'change' }],
        classId: [{ required: true, message: '请选择数据表', trigger: 'change' }],
        processUserId: [{ required: true, message: '请选择审批人', trigger: 'change' }],
      },
      submitLoading: false,
      addClassList: [],
      userList: [],
      resourceId: '',
      timer: null, // 防抖
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  computed: {
    query() {
      return this.$route.query
    },
  },
  watch: {
    // query(val) {
    //   this.setPage(val)
    // },
    standardId(newVal) {
      if (newVal) {
        this.approvalTable = ''
        this.getClassList()
        this.getTableData()
      }
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    async getTableData() {
      this.tableLoading = true
      const res = await dataService.getList({
        StandardId: this.standardId,
        SkipCount: this.page.pageNo,
        MaxResultCount: this.page.pageSize,
        Sorting: '',
        BatchCode: this.approvalNum,
        ClassId: this.approvalTable,
        ProcessStatus: this.approvalStatus,
        StartDate: this.startDate,
        EndDate: this.endDate,
        ProcessUserId: this.approvalUser,
      })
      if (res && res.code === 0 && !_.isNil(res.data)) {
        this.tableData = res.data
        this.page.recordCount = res.totalCount
        this.$nextTick(() => {
          this.$refs.tableList.doLayout()
        })
      }
      this.tableLoading = false
    },
    searchTableData() {
      this.page.pageNo = 1
      this.getTableData()
    },
    /**
     * @function 跳往详情或审批
     * @data 审批行
     * @type 跳转类型
     */
    toDetail(data, type) {
      this.$router.push({
        path: './data-preview',
        query: {
          taskRunId: data.taskRunId,
          classId: data.classId,
          id: data.id,
          type,
        },
      })
    },
    deleteRow(data) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await dataService.deleteRow({
          ids: [data.id],
        })
        if (res && res.code === 0) {
          this.$message.success('删除成功!')
          this.searchTableData()
        }
      })
    },
    setPage(query) {
      if (_.isEmpty(query)) {
        this.getTableData()
      }
    },
    // 获取标准下拉列表
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.getClassList()
      }
    },
    // 获取标准库下的数据表
    async getClassList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    // 重置
    reset() {
      this.approvalNum = ''
      this.approvalTable = ''
      this.approvalStatus = ''
      this.startDate = ''
      this.endDate = ''
      this.approvalUser = ''
      this.page.pageNo = 1
      this.page.pageSize = 15
    },
    async openDialog(type, row) {
      this.submitLoading = false
      this.type = type
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      if (type === 'edit') {
        this.form.standardId = _.find(this.standardList, { name: row.standardName }).id
        await this.getApprovalTable()
        this.form.classId = row.classId
        this.form.batchCode = row.batchCode
        this.form.processUserId = row.processUserId
        this.form.id = row.id
      } else {
        // 新增
        this.form.standardId = this.standardId
        this.form.standardCode = _.find(this.standardList, { id: this.standardId }).code
        this.form.classId = ''
        this.form.classCode = ''
        this.form.processUserId = ''
        this.getApprovalTable()
      }
    },
    submitData() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let res
          if (this.timer) clearTimeout(this.timer)
          this.timer = setTimeout(async () => {
            if (this.type === 'edit') {
              res = await dataService.editApproval({
                id: this.form.id,
                processUserId: this.form.processUserId,
              })
            } else {
              res = await dataService.addApproval(this.form)
            }
            if (res && res.code === 0) {
              this.$message.success('保存成功')
              this.visible = false
              this.getTableData()
            }
          }, 1000)
        }
      })
    },
    // 获取需要审批的数据表
    async getApprovalTable() {
      const res = await dataService.getApprovalTable({ standardId: this.form.standardId })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.addClassList = res.data
      }
    },
    changeAddStandardId(val) {
      this.form.standardCode = _.find(this.standardList, { id: val }).name
      this.form.classId = ''
      this.addClassList = []
      this.getApprovalTable()
    },
    changeAddClassId(val) {
      this.form.classCode = _.find(this.addClassList, { id: val }).name
    },
    /**
     * @function 获取用户
     */
    async getCharactor() {
      const fileServer = Wiz.GetModuleServer('system-management')
      const res = await axios.get(
        `${fileServer}/api/eaf-user-role/get-users?SkipCount=0&MaxResultCount=999`
      )
      if (res && res.data && res.status === 200) {
        this.userList = res.data.items
      }
    },
  },
  async created() {
    await this.getCharactor()
    await this.getStandardList()
    if (this.standardId) {
      this.getTableData()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-dialog {
  height: 400px;
}
.addDialog {
  padding: 0 100px;
  // .el-select {
  //   width: 100%;
  // }
}

</style>
